import React, { useState, useEffect } from "react";
import axios from "axios";

import "./App.css";
import {
  MenuItem,
  FormControl,
  Select,
  Card,
  CardContent,
} from "@material-ui/core";
import InfoBox from "../src/InfoBox/InfoBox";
import LineGraph from "../src/LineGraph/LineGraph";
import Table from "../src/Table/Table";
import { sortData, prettyPrintStat } from "./functions";
import numeral from "numeral";
import CovidMap from "../src/Map/CovidMap";
import "leaflet/dist/leaflet.css";

const App = () => {
  const [country, setInputCountry] = useState("worldwide");
  const [countryInfo, setCountryInfo] = useState({});
  const [countries, setCountries] = useState([]);
  const [mapCountries, setMapCountries] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [casesType, setCasesType] = useState("cases");
  const [mapCenter, setMapCenter] = useState([34, -40]);
  const [mapZoom, setMapZoom] = useState(3);

  useEffect(() => {
    const fetchData = () => {
      axios
        .get("https://disease.sh/v3/covid-19/all")
        .then((response) => {
          const data = response.data;
          setCountryInfo(data);
        })
        .catch((error) => {
          console.error("Veri çekme hatası:", error);
        });
    };

    fetchData();
  }, []);

  useEffect(() => {
    const getCountriesData = async () => {
      try {
        const response = await axios.get(
          "https://disease.sh/v3/covid-19/countries"
        );
        const data = response.data;

        const countries = data.map((country) => ({
          name: country.country,
          value: country.countryInfo.iso2,
        }));
        let sortedData = sortData(data);
        setCountries(countries);
        setMapCountries(data);
        setTableData(sortedData);
      } catch (error) {
        console.error("Fetch Error:", error);
      }
    };

    getCountriesData();
  }, []);

  const onCountryChange = (e) => {
    const countryCode = e.target.value;

    const url =
      countryCode === "worldwide"
        ? "https://disease.sh/v3/covid-19/all"
        : `https://disease.sh/v3/covid-19/countries/${countryCode}`;

    axios
      .get(url)
      .then((response) => {
        const data = response.data;
        setInputCountry(countryCode);
        setCountryInfo(data);
        setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
        setMapZoom(5);
      })
      .catch((error) => {
        console.error("Fetch Error:", error);
      });
  };
  console.log(mapCenter, mapZoom);

  return (
    <div className="app">
      <div className="left">
        <div className="header">
          <h1>Caner Demir COVID Tracker</h1>
          <FormControl className="dropdown">
            <Select
              variant="outlined"
              value={country}
              onChange={onCountryChange}
            >
              <MenuItem value="worldwide">Worldwide</MenuItem>
              {countries.map((country) => (
                <MenuItem value={country.value}>{country.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <LineGraph className="graph" casesType={casesType} />
        </div>
        <div className="stats">
          <InfoBox
            onClick={(e) => setCasesType("cases")}
            title=" Cases"
            isRed
            active={casesType === "cases"}
            cases={prettyPrintStat(countryInfo.todayCases)}
            total={numeral(countryInfo.cases).format("0.0a")}
          />
          <InfoBox
            onClick={(e) => setCasesType("recovered")}
            title="Recovered"
            active={casesType === "recovered"}
            cases={prettyPrintStat(countryInfo.todayRecovered)}
            total={numeral(countryInfo.recovered).format("0.0a")}
          />
          <InfoBox
            onClick={(e) => setCasesType("deaths")}
            title="Deaths"
            isRed
            active={casesType === "deaths"}
            cases={prettyPrintStat(countryInfo.todayDeaths)}
            total={numeral(countryInfo.deaths).format("0.0a")}
          />
        </div>

        <CovidMap
          countries={mapCountries}
          casesType={casesType}
          center={mapCenter}
          zoom={mapZoom}
          showDataOnMap
        />
      </div>
      <Card className="right">
        <CardContent>
          <div className="information">
            <h3>Live Cases by Country</h3>
            <Table countries={tableData} />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default App;
